export default function({ $axios, redirect, app }) {
  $axios.onError(error => {
    console.log('$axios.onError statusCode:', error.response.status);
    console.log('$axios.onError path:', error.response.config.url);
    // redirect(307, '/');
    // return;
  });

  var pathname = '';
  if (process.env.VUE_ENV === 'server') {
    pathname = app.context.req._parsedUrl.href;
  } else {
    pathname = window.location.href;
  }

  $axios.onRequest(config => {
    // config.headers.Authorization =
    //   app.$cookies.get('drushim_auth_token.local') || '';
    config.headers['Content-Type'] = 'application/json';
    config.headers['Access-Control-Allow-Credentials'] = true;
    config.headers['X-alt-referrer'] = pathname;

    if (process.env.VUE_ENV === 'server') {
      config.headers['Access-Control-Allow-Origin'] =
        app.context.req.headers.host;
    } else {
      config.headers['Access-Control-Allow-Origin'] = '*';
    }
  });
}
